<template>
  <el-dialog
    title="注册"
    :visible.sync="dialogVisible"
    width="30%"
   >
   <Layout>
    <el-form
      :model="form"
      :rules="rules"
      ref="form">
      <el-form-item prop="companyName">
        <el-input
          v-model="form.companyName"
          prefix-icon="el-icon-office-building"
          placeholder="请输入公司名称"></el-input>
      </el-form-item>
      <el-form-item prop="userName">
        <el-input
          v-model="form.userName"
          prefix-icon="el-icon-user"
          placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="form.password"
          show-password
          prefix-icon="el-icon-lock"
          placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item prop="rePassword">
        <el-input
          v-model="form.rePassword"
          show-password
          prefix-icon="el-icon-lock"
          placeholder="确认密码"></el-input>
      </el-form-item>
      <el-form-item prop="phone">
        <el-input
          v-model="form.phone"
          prefix-icon="el-icon-mobile-phone"
          placeholder="手机"></el-input>
      </el-form-item>
      <el-form-item>
        <div class="valicode-row">
          <el-input
            v-model="validationCode"
            class="valicode-input"
            placeholder="验证码" />
          <div class="valicode-pic">
            <img :src="byteImg" />
          </div>
          <div class="valicode-btn">
            看不清楚?<el-button @click="getValiCodePic" class="link" type="link">换一张</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item prop="identityCode">
        <div class="valicode-row">
          <el-input v-model="form.identityCode" class="valicode-msg-input" placeholder="验证码" />
          <el-button
            :disabled="disabledValiTelCodeBtn"
            class="valicode-msg-btn"
            type="info"
            @click="getTelCode"
            plain>{{ telCodeCD ? `已发送(${telCodeCDNum}S)` : '获取验证码'}}</el-button>
        </div>
      </el-form-item>
      <el-form-item
        class="mt-30">
        <PrimaryBtn
          @click="primaryBtnClick">
          立即注册
        </PrimaryBtn>
      </el-form-item>
    </el-form>
    <div class="footer">
      已有账号？<el-button class="link" type="link" @click="handleLogin">立即登录</el-button>
    </div>

    
  </Layout>
</el-dialog>
</template>

<script>
import Layout from './components/LoginLayout'
import PrimaryBtn from './components/LoginPrimaryBtn'
import {registerServer, phoneIsExists, getValiCodePicSrc, getTelValiCode} from './servers.js'

export default {
  components: {
    Layout,
    PrimaryBtn
  },
  data() {
    const checkPhone = async (rule, value, cb) => {
      try {
        const isExists = await phoneIsExists(value)
        isExists ? cb(new Error(isExists)) : cb();
      } catch (error) {
        cb(new Error('校验已注册手机号失败'))
      }
    }
    const checkPsw = (rule, value, cb) => {
      const _len = value.length;
      if (_len < 8 || _len > 20) {
        cb(new Error('密码长度为8～20位字符'))
      } else if (!/[a-zA-Z]/.test(value) || !/[0-9]/.test(value) || /[ ]/.test(value)) {
        cb(new Error('密码需要同时包含数字和字母且不能有空格'))
      } else if (/[^a-zA-Z0-9~!@#^%&_\-,./?=]/.test(value)) {
        cb(new Error('密码仅支持~!@#^%&_-,（英文逗号）.（英文点号）/?='))
      } else {
        cb()
      }
    }
    const checkRePsw = (rule, value, cb) => {
      if (value !== this.form.password) {
        cb(new Error('两次输入的密码不一致'))
      } else {
        cb()
      }
    }

    return {
      dialogVisible: false,
      byteImg: '',
      validationCode: '',
      form: {
        companyName: '',
        userName: '',
        password: '',
        rePassword: '',
        phone: '',
        identityCode: ''
      },
      rules: {
        companyName: [
          {required: true, message: '请输入公司名称', trigger: 'blur'}
        ],
        userName: [
          {required: true, message: '请输入账号', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 8, max: 20, message: '长度在8-20个字符', trigger: 'change'},
          {validator: checkPsw, trigger: 'change'}
        ],
        rePassword: [
          {required: true, message: '请再次输入密码', trigger: 'blur'},
          {validator: checkRePsw, trigger: 'change'}
        ],
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {len: 11, message: '手机号码须为11位', trigger: 'change'},
          {validator: checkPhone, trigger: 'blur'}
        ]
      },
      telCodeCD: false,
      telCodeCDNum: 60,
      timmer: null
    }
  },
  computed: {
    disabledValiTelCodeBtn() {
      console.log("vvv==", !this.form.phone || !this.validationCode || this.telCodeCD)
      return false
    }
  },
  methods: {
    method_open() {
      this.dialogVisible = true
    },
    method_close() {
      this.dialogVisible = false
    },
    handleLogin() {
      this.$emit('login')
    },
    async getValiCodePic() {
      try {
        const src = await getValiCodePicSrc()
        if (!src) return ;
        this.byteImg = src
      } catch (error) {
        console.log(error)
      }
    },
    async getTelCode() {
      if (!this.form.phone) return this.$message.warning('请填写手机号')
      if (!this.validationCode) return this.$message.warning('请填写图片验证码')
      try {
        const success = await getTelValiCode({
          phoneNum: this.form.phone,
          validationCode: this.validationCode,
          status: 0
        })
        console.log(success);
        if (success) {
          this.setupTelCodeCD()
        } else {
          this.getValiCodePic()
        }
      } catch (error) {
        this.getValiCodePic()
        console.log(error)
      }
    },
    setupTelCodeCD() {
      this.telCodeCD = true
      this.timmer = setInterval(() => {
        this.telCodeCDNum--
        if (this.telCodeCDNum < 1){
          this.clearTelCodeCD()
        }
      }, 1000)
    },
    clearTelCodeCD() {
      this.telCodeCD = false
      this.telCodeCDNum = 60
      this.timmer && clearInterval(this.timmer)
      this.timmer = null
    },
    primaryBtnClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.register();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async register() {
      try {
        const data = {
          ...this.form
        }
        const res = await registerServer(data)
        if (typeof res === 'string') {
          this.$message.error(res)
          return;
        }
        if (res) {
          this.$message.success('注册成功，请登录')
          // this.$router.replace({name: 'l_index', params: {
          //   userName: this.form.userName,
          //   companyName: this.form.companyName,
          //   password: this.form.password
          // }})
          this.$emit('login')
        } else {
          this.validationCode = ''
          this.getValiCodePic()
        }
      } catch (error) {
        console.log(error)
        this.validationCode = ''
        this.getValiCodePic()
      }
    }
  },
  created() {
    this.getValiCodePic()
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header{
  background-color: #396CF3;
}
.mt-40 {
  margin-top: 40px;
}
.footer {
  text-align: center;
  color: #9c9c9c;
  font-size: 13px;
  margin-bottom: 40px;

  .link {
    padding: 0;
    color: #396CF3;
  }
}
.phoneCodeMsg {
  padding: 10px 0;
  color: red;
  border-top: 1px solid #ccc;
}
.valicode-row {
  display: flex;
  align-items: center;
  font-size: 12px;
  .link {
    padding: 0;
    color: #396CF3;
  }

  .valicode-input {
    width: 110px;
    margin-right: 8px;
  }
  .valicode-pic {
    margin-right: 8px;
    width: 121px;
    height: 40px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .valicode-msg-input {
    width: 239px;
    margin-right: 10px;
  }
  .valicode-msg-btn {
    padding: 0 18px;
    height: 40px;
    border-radius: 4px;
  }
}
.phoneCodeTip {
  color: #4b8b38;
}
.phoneCodeTipError {
  color: red;
}
</style>